import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=555f8edc&scoped=true"
import script from "./AuthView.vue?vue&type=script&lang=ts"
export * from "./AuthView.vue?vue&type=script&lang=ts"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=555f8edc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "555f8edc",
  null
  
)

export default component.exports